<template>
  <div class="form-group checklist d-flex align-items-center m-0">
    <div class="btn-group" data-toggle="buttons">
      <label
        :class="`btn btn-default checklist__item border ${
          modelValue === 'OK' ? 'active' : ''
        }`"
      >
        <input
          type="radio"
          :name="name"
          :id="`${name}-option-OK`"
          :checked="modelValue === 'OK'"
          :readonly="!editable"
          :disabled="!editable"
          @change="handleModelInputChanged"
          value="OK"
          aria-label="OK"
          autocomplete="off"
        />
        <span class="checklist__item__icon">
          <font-awesome-icon :icon="['fas', 'check']"></font-awesome-icon>
        </span>
      </label>

      <label
        :class="`btn btn-default checklist__item border ${
          modelValue === 'NC' ? 'active' : ''
        }`"
      >
        <input
          type="radio"
          :name="name"
          :id="`${name}-option-NC`"
          :checked="modelValue === 'NC'"
          :readonly="!editable"
          :disabled="!editable"
          @change="handleModelInputChanged"
          value="NC"
          aria-label="NC"
          autocomplete="off"
        />
        <span class="checklist__item__icon">
          <font-awesome-icon :icon="['fas', 'check']"></font-awesome-icon>
        </span>
      </label>

      <label
        :class="`btn btn-default checklist__item border ${
          modelValue === 'NA' ? 'active' : ''
        }`"
      >
        <input
          type="radio"
          :name="name"
          :id="`${name}-option-NA`"
          :checked="modelValue === 'NA'"
          :readonly="!editable"
          :disabled="!editable"
          @change="handleModelInputChanged"
          value="NA"
          aria-label="NA"
          autocomplete="off"
        />
        <span class="checklist__item__icon">
          <font-awesome-icon :icon="['fas', 'check']"></font-awesome-icon>
        </span>
      </label>
    </div>

    <div class="title ml-2">{{ label }}</div>

    <div v-if="modelValue === 'NC'">
      <div class="input-group input-group-sm ml-2">
        <button
          class="btn btn-sm btn-secondary"
          type="button"
          @click="handleSelectFiles"
        >
          <font-awesome-icon :icon="['fas', 'paperclip']"></font-awesome-icon>
        </button>
        <div
          class="form-control"
          aria-label="Example text with button addon"
          aria-describedby="button-addon1"
        >
          {{ images.length }} Imagens anexadas
        </div>
      </div>
      <input
        ref="fileInput"
        @change="handleSelectedFiles"
        type="file"
        multiple
        :name="`images-${name}`"
        style="display: none"
      />
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      editable: {
        type: Boolean,
        required: false,
        default: true,
      },
      name: {
        type: String,
        required: true,
      },
      label: {
        type: String,
        required: true,
      },
      modelValue: {
        type: String,
        required: false,
        default: '',
      },
    },
    emits: ['update:modelValue'],
    data() {
      return {
        images: [],
      }
    },
    methods: {
      handleModelInputChanged($event) {
        const currentValue = $event.target.value
        this.$emit('update:modelValue', currentValue)
      },
      handleSelectFiles() {
        this.$refs.fileInput.click()
      },
      handleSelectedFiles() {
        this.images = this.$refs.fileInput.files
      },
    },
  }
</script>

<style lang="scss" scoped>
  .checklist {
    &__item,
    &__subitem {
      margin: 0;

      input[type='radio'] {
        display: none;
      }

      &.active {
        .checklist__item__icon,
        .checklist__subitem__icon {
          opacity: 1;
        }
      }

      .checklist__item__icon,
      .checklist__subitem__icon {
        opacity: 0;
      }
    }
  }
</style>
